import { Spacer } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import LoadingOverlay from 'components/LoadingOverlay';
import { isPollingSocialPostCaptionsSelector } from 'redux/modules/download';
import SocialShareModalAccountSelect from '../SocialShareModalAccountSelect';
import { useSocialShareModal } from '../SocialShareModalContext';
import SocialShareModalRegenerateTextButton from '../SocialShareModalRegenerateTextButton';
import { useSocialSharePlatform } from '../SocialSharePlatforms';
import { socialShareModalBlock as block } from '../utils';

export type SocialShareModalBodyProps = {
  showHeader?: boolean;
  showRegenerateTextButton?: boolean;
  loadingTitle?: string;
  isLoading?: boolean;
  className?: string;
  children?: React.ReactNode;
};

const SocialShareModalBody: React.FC<SocialShareModalBodyProps> = ({
  showHeader = true,
  showRegenerateTextButton = true,
  loadingTitle,
  isLoading = false,
  className,
  children,
}) => {
  const isPollingSocialPostCaptions = useSelector(
    isPollingSocialPostCaptionsSelector,
  );

  const { isSchedulingPost } = useSocialShareModal();
  const { platformAlias, authenticating } = useSocialSharePlatform();

  const shouldShowLoadingOverlay =
    authenticating ||
    isPollingSocialPostCaptions ||
    isSchedulingPost ||
    isLoading;

  return (
    <>
      {shouldShowLoadingOverlay && (
        <LoadingOverlay
          title={
            isSchedulingPost
              ? 'Scheduling video'
              : isLoading
              ? loadingTitle
              : undefined
          }
        />
      )}

      <div
        className={cn(
          block('body-container', { [platformAlias]: true }),
          className,
        )}
      >
        {showHeader && (
          <Spacer
            orientation="horizontal"
            align="center"
            justify="space-between"
            className={block('header-container')}
          >
            {authenticating ? <div /> : <SocialShareModalAccountSelect />}

            {showRegenerateTextButton && (
              <SocialShareModalRegenerateTextButton />
            )}
          </Spacer>
        )}

        {children}
      </div>
    </>
  );
};

export default SocialShareModalBody;
